import React, { useEffect, useState } from "react";
import "./progress.scss";

const ProgressBar = (props: any) => {
  const { uploadProgress } = props;

  return (
    <div className="circular_progress_bar">
      <CirCularProgressBar percentage={uploadProgress} circleWidth={80} />
      <p>Submitting...</p>
    </div>
  );
};

export default ProgressBar;

const CirCularProgressBar = (props: any) => {
  const { percentage, circleWidth } = props;
  const radius = 30;
  const dashArray = radius * Math.PI * 2;
  const dashOffset = dashArray - (dashArray * percentage) / 100;
  return (
    <div className="progressbar">
      <svg
        width={circleWidth}
        height={circleWidth}
        viewBox={`0 0 ${circleWidth} ${circleWidth}`}
      >
        <circle
          cx={circleWidth / 2}
          cy={circleWidth / 2}
          strokeWidth="10px"
          r={radius}
          className="circle-bg"
        />
        <circle
          cx={circleWidth / 2}
          cy={circleWidth / 2}
          strokeWidth="10px"
          r={radius}
          className="circle-progress"
          style={{
            strokeDasharray: dashArray,
            strokeDashoffset: dashOffset,
          }}
          transform={`rotate(-90 ${circleWidth / 2} ${circleWidth / 2})`}
        />
        <text
          x="50%"
          y="50%"
          dy="0.3em"
          textAnchor="middle"
          className="circle_text"
          fill="white"
        >
          {percentage}%
        </text>
      </svg>
    </div>
  );
};
